import { BadgeLabel } from './ui';

export const today = () => new Date().toLocaleDateString('en-CA');

export const shortId = (id?: string) => (id ? `${id.slice(0, 8)}…${id.slice(-4)}` : '—');

export const ageInSeconds = (iso?: string | null) =>
  iso ? Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000)) : 0;

export const formatAge = (seconds: number) => {
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}min ${seconds % 60}s`;
  return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}min`;
};

export const formatDateTime = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }) : '—';

const DELIVERY_COLORS: Record<string, BadgeLabel['color']> = {
  original: 'gray',
  replay: 'purple',
  snapshot: 'teal',
};

export const deliveryLabel = (delivery: string, deliveryFormatted: string): BadgeLabel => ({
  text: deliveryFormatted,
  color: DELIVERY_COLORS[delivery] ?? 'gray',
});
